import type { SVGProps } from 'react'

const SvgSortArrowUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_39678_22064)">
      <path
        d="M5.295 2.70404L6 1.99904L4 -0.000955669L2 1.99904L2.705 2.70404L3.5 1.91404V6.74219L4.5 6.74219L4.5 1.91404L5.295 2.70404Z"
        fill="currentColor"
      />
      <path
        d="M7.56437 8.00959L6.85937 8.71459L8.85937 10.7146L10.8594 8.71459L10.1544 8.00959L9.35937 8.79959V0.857422H8.35937V8.79959L7.56437 8.00959Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_39678_22064">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0 12) rotate(-90)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgSortArrowUser
